import {
  AddErrorMessage,
  MessageDictionary,
} from '__pages/AutomationEngine/messageDictionary';
import { NewEntityCreatedValues } from './common';

const forApi = (
  step: NewEntityCreatedValues,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary
) => {
  return step;
};

type ApiObject = any;

const forFlow = (
  apiObject: ApiObject,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary,
  stepType: any
) => {
  return apiObject;
};

export const newEntityCreatedDTO = {
  forApi,
  forFlow,
};
